import { RouteProps, match, matchPath } from 'react-router'
import { RouterState } from 'react-router-redux'

export const infoRoute: RouteProps = {
  path: '/info'
}
export const photoRoute: RouteProps = {
  path: '/photo/:id'
}

export interface PhotoProps {
  readonly id: string
}

export function matchPhotoRoute (path: string): match<PhotoProps> | null {
  const routeMatch = matchPath<PhotoProps>(path, photoRoute)
  if (!routeMatch) {
    return null
  }
  return routeMatch
}

export default RouterState



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/states/RouterState.ts